const ExamStart = () => {
    return (
        <div>EXAM START Page Here!!</div>
    )
}

export default ExamStart;